import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { CodeTemplateGroup } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("CODE_TEMPLATE_GROUPS_MODULE");

export const moduleActions = createDataModuleActions<CodeTemplateGroup>(actionCreator);
export const getCodeTemplateGroupsTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const codeTemplateGroupsActions = {
  ...normalizeActions(moduleActions.data),
};
export const codeTemplateGroupsActionCreators = {
  ...moduleActions,
};
